"use client";

import React from "react";
import { Paperclip } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Button,
  ScrollArea,
  Tooltiper,
} from "visuais";
import { useCompactAttachmentsDialog } from "./_hook";
import { UploadArea } from "./UploadArea";
import { AnexoList } from "./AnexoList";

// =================================================================
// COMPONENTE PRINCIPAL: CompactAttachmentsDialog
// =================================================================
export function CompactAttachmentsDialog() {
  const {
    // Estados
    isPopoverOpen,
    localAnexos,
    selectedFiles,
    fileDescriptions,
    draft,
    isUploading,

    // Handlers
    setIsPopoverOpen,
    handleFilesSelected,
    handleFileDescriptionChange,
    clearSelectedFiles,
    removeSelectedFile,
    handleUpload,

    // Utilitários
    getUploadButtonText,

    // Computed
    isUploadDisabled,
    canAddMoreFiles,
    uploadConfig,
  } = useCompactAttachmentsDialog();

  return (
    <div className="flex justify-center">
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <Tooltiper
          content="Adicione os anexos da pré-nota"
          variant="info"
          side="bottom"
          sideOffset={8}
        >
          <PopoverTrigger asChild>
            <Button
              variant="secondary"
              className="hover:border-2 border bg-popover transition-all duration-300 text-[9pt] hover:border-foreground"
            >
              <Paperclip className="size-4" />
              Anexos ({draft.anexos.length})
            </Button>
          </PopoverTrigger>
        </Tooltiper>
        <PopoverContent className="w-96 p-4" align="end">
          <div className="space-y-4">
            {/* Header com informações */}
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Anexos da Pré-nota</h3>
              <div className="text-xs text-muted-foreground">
                {localAnexos.length}/{uploadConfig.maxFiles} arquivos
              </div>
            </div>

            {/* Área de Upload */}
            <UploadArea
              onFilesSelected={handleFilesSelected}
              selectedFiles={selectedFiles}
              fileDescriptions={fileDescriptions}
              onFileDescriptionChange={handleFileDescriptionChange}
              onClearFiles={clearSelectedFiles}
              onRemoveFile={removeSelectedFile}
              disabled={!canAddMoreFiles}
              isUploading={isUploading}
              maxFiles={uploadConfig.maxFiles}
              currentFileCount={localAnexos.length}
            />

            {/* Botão de Upload */}
            {selectedFiles.length > 0 && (
              <Button
                onClick={handleUpload}
                disabled={isUploadDisabled}
                className="w-full h-8 text-xs"
              >
                {getUploadButtonText()}
              </Button>
            )}

            {/* Lista de Anexos */}
            {localAnexos.length > 0 && (
              <div className="space-y-2">
                <h4 className="text-xs font-medium text-muted-foreground">
                  Arquivos Anexados
                </h4>
                <ScrollArea className="max-h-60">
                  <AnexoList anexos={localAnexos} />
                </ScrollArea>
              </div>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
